<template>
  <div id="app">
    
    <router-view></router-view>
    <!-- <Menu /> -->
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  background-color:transparent !important;
}
	html {
    height:100vh;
		background-image: linear-gradient(to bottom right, #57D9A6, #47A384);
	}
@import url('https://fonts.googleapis.com/css?family=Open+Sans');

html, body {
  font-family: 'Roboto Condensed', sans-serif;
}

</style>
